import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { ErrorTypes, ValidationError } from 'modules/attendance/lib/validateShiftBreakDurationRules'

interface Props {
  onClose: () => void
  onClockOut: () => void
  onClockOutAndFix: () => void
  inconsistencyErrors: ValidationError[]
}

const ClockOutInconsistenciesAlert = ({
  onClose,
  onClockOut,
  onClockOutAndFix,
  inconsistencyErrors,
}: Props) => {
  useEffect(() => {
    const pathname = window.location.href.includes('attendance') ? 'attendance' : 'dashboard'
    const inconsistenciesType = inconsistencyErrors
      ?.map((inconsistency) => inconsistency.error)
      .join(',')
    track(trackingEvents.timeTracking.inconsistenciesModalDisplayed, {
      path_name: pathname,
      inconsistencies_type: inconsistenciesType,
    })
  }, [])
  const restTimeErrors = inconsistencyErrors.filter((error) => error.error === ErrorTypes.REST_TIME)
  const totalErrors =
    (inconsistencyErrors.length ?? 0) -
    ((restTimeErrors.length ?? 0) > 1 ? (restTimeErrors.length ?? 0) - 1 : 0)

  const handleOnClose = () => {
    track(trackingEvents.timeTracking.inconsistenciesModalActionTaken, {
      modal_type: 'clock out inconsistencies modal',
      action: 'cancel',
    })
    onClose()
  }

  const handleOnClockOut = () => {
    track(trackingEvents.timeTracking.inconsistenciesModalActionTaken, {
      modal_type: 'clock out inconsistencies modal',
      action: 'clock out',
    })
    onClockOut()
  }

  const handleOnClockOutAndFix = () => {
    track(trackingEvents.timeTracking.inconsistenciesModalActionTaken, {
      modal_type: 'clock out inconsistencies modal',
      action: 'clock out and fix',
    })
    onClockOutAndFix()
  }

  return (
    <Modal
      illustration="alert"
      title={i18n.tp('time_tracking.modals.rest_time_alerts.clock_out.title', {
        count: totalErrors,
      })}
      description={i18n.t('time_tracking.modals.rest_time_alerts.clock_out.description')}
      onClose={handleOnClose}
      footer={
        <Box flexDirection="row" alignItems="flexEnd" gap="s8">
          <Button type="secondary" onClick={() => handleOnClockOut()}>
            {i18n.t('time_tracking.modals.rest_time_alerts.secondary_button')}
          </Button>
          <Button type="primary" onClick={() => handleOnClockOutAndFix()}>
            {i18n.t('time_tracking.modals.rest_time_alerts.primary_button')}
          </Button>
        </Box>
      }
    ></Modal>
  )
}

export default ClockOutInconsistenciesAlert
